<div :class="'property text-' + getColor(item.points)">
    {{formatText(item.title)}}
</div>
